import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Overview",
    b: "This Cookie Policy describes how the Vaultavo website (vaultavo.com) uses cookies and similar technologies. Vaultavo's institutional product surfaces (custody platform, device firmware, partner integrations) do not rely on cookies and are governed by separate agreements.",
  },
  {
    h: "Strictly necessary cookies",
    b: "We use a minimal set of strictly necessary cookies to operate the website — for example, to remember whether you have dismissed a banner, to maintain session continuity on the contact form and to mitigate abuse. These cookies cannot be disabled without breaking core site functionality.",
  },
  {
    h: "Analytics and measurement",
    b: "Where analytics tooling is enabled, it is configured to anonymise IP addresses and to disable cross-site tracking. We do not sell, share, or use website-derived personal data for advertising.",
  },
  {
    h: "No third-party advertising",
    b: "Vaultavo does not run third-party advertising, does not embed advertising networks and does not participate in retargeting or behavioural advertising ecosystems on this website.",
  },
  {
    h: "Managing cookies",
    b: "You can control or delete cookies through your browser settings. Disabling strictly necessary cookies may impair website functionality.",
  },
  {
    h: "Contact",
    b: "Questions about this Cookie Policy: hello@vaultavo.com",
  },
];

export default function Cookies() {
  return (
    <LegalPage
      testid="cookies-page"
      kicker="Cookie Policy"
      title="Cookies and similar technologies on vaultavo.com."
      summary="A short, plain-language description of cookies set by the Vaultavo website and how to control them."
      lastUpdated="Feb 2026"
      sections={SECTIONS}
    />
  );
}
